import React from "react";
// import Preloader from "./components/Preloader/Preloader";
// import Timer from "./components/Countdown/Timer";
// import Optin from "./components/Optin/Optin";
import Header from "../../components/Header/Header";
import NavBar from "../../components/NavBar/NavBar";

import "./ComingSoon.css";
import { useForm } from "react-hook-form";
import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";

function ComingSoon() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (values) => alert("Success");
  return (
    <div className="CommingSoon">
      <Header />
      <NavBar />
      <div>
        <div className="CommingSoonheader">
          <h2 className="heading font-light">
            We are Launching <span className="font-bold">soon!</span>
          </h2>
          <p>Subscribe and get notified</p>

          <form className="form" onSubmit={handleSubmit(onSubmit)} >
            <input
              className="input-field"
              type="text"
              placeholder="Your Email Address..."
              {...register("email", {
                required: true,
                pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
              })}
            />
            <button type="submit" className="submit-btn cursor-pointer">
              Notify Me
            </button>
          </form>
          {errors.email && <span className="error">Invalid email</span>}
          <div className="icons-container" style={{marginTop:'5%'}}>
        <FaFacebook color="hsl(223, 87%, 63%)" size={30} />
        <FaTwitter color="hsl(223, 87%, 63%)" size={30} />
        <FaInstagram color="hsl(223, 87%, 63%)" size={30} />
      </div>
        </div>
      </div>
    </div>
  );
}

export default ComingSoon;
